module.exports = __webpack_public_path__ + "static/img/2_1_3_1.c495b3d1.jpg";